import useStableSearchParams from '@/hooks/useStableSearchParams';
import { useCallback } from 'react';

function useLiveMode() {
  const [searchParams, setSearchParams] = useStableSearchParams();

  const liveMode = searchParams.get('live') === '1';

  // Default dateRange to 3 days ago to now if not present

  const setLiveModeInUrl = useCallback(
    (mode) => {
      setSearchParams((prev) => {
        const nextParams = new URLSearchParams(prev);
        nextParams.set('live', mode ? '1' : '0');
        return nextParams;
      });
    },
    [setSearchParams],
  );

  return [liveMode, setLiveModeInUrl];
}

export default useLiveMode;
